import React from "react";

export default function SignatureLogo() {
  return (
    <React.Fragment>
      <svg
        width="60"
        height="60"
        viewBox="0 0 60 60"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M33 54C44.598 54 54 44.598 54 33C54 21.402 44.598 12 33 12C21.402 12 12 21.402 12 33C12 44.598 21.402 54 33 54Z"
          fill="#84F5BA"
        />
        <circle
          cx="30"
          cy="30"
          r="22"
          fill="white"
          stroke="#222222"
          strokeWidth="2"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M39 38H21V36H39V38Z"
          fill="#222222"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M22.0001 26.0166C21.9635 23.8234 23.1965 22 25 22C25.7788 22 26.5781 22.3158 27.1587 23.0485C27.7206 23.7575 28 24.7565 28 26C28 27.266 27.4785 28.6211 26.5979 30.0301C26.411 30.3291 26.2056 30.6343 25.9819 30.9455C26.0977 31.1205 26.2053 31.2736 26.3 31.4C26.6591 31.8788 26.965 32.236 27.2283 32.4864C27.499 32.7439 27.6707 32.8361 27.7537 32.8638C27.7846 32.8741 27.7843 32.873 27.7837 32.8709L27.7842 32.8688C27.8297 32.8454 27.9647 32.7502 28.168 32.4453L30.1679 29.4453C30.3997 29.0977 30.8232 28.9307 31.2298 29.0268C31.6365 29.1228 31.9405 29.4615 31.9923 29.8761C32.0231 30.1232 32.0504 30.352 32.0759 30.5662C32.122 30.9529 32.1624 31.2921 32.2081 31.6059C32.2789 32.0918 32.3504 32.4205 32.4361 32.649C32.5171 32.8652 32.5832 32.916 32.602 32.9291C32.6152 32.9383 32.6602 32.9668 32.7739 32.9847C32.9117 32.844 33.078 32.6383 33.2738 32.3863C33.3063 32.3445 33.3401 32.3008 33.3746 32.2561C33.5301 32.0549 33.7023 31.8321 33.8551 31.6564C33.9485 31.549 34.0652 31.4229 34.1936 31.3164C34.2583 31.2627 34.349 31.1944 34.4614 31.1358C34.5664 31.081 34.7557 31 35 31C35.3264 31 35.6319 31.1002 35.8807 31.2096C36.1413 31.3241 36.4137 31.4822 36.6925 31.6681C37.2499 32.0398 37.9113 32.5757 38.6685 33.2563L39 33.5543L37.663 35.0417L37.3315 34.7437C36.6057 34.0913 36.0256 33.6272 35.583 33.3321C35.4482 33.2423 35.3335 33.173 35.2376 33.1208C35.1588 33.2185 35.0722 33.3305 34.9746 33.4566C34.9359 33.5067 34.8954 33.5591 34.8529 33.6137C34.6611 33.8604 34.4289 34.1539 34.1988 34.3882C34.084 34.5051 33.9414 34.6368 33.7793 34.7452C33.6366 34.8407 33.3601 35 33 35C32.4536 35 31.9195 34.8905 31.4601 34.571C30.9997 34.2508 30.7324 33.8017 30.5634 33.3513C30.4903 33.1562 30.4308 32.948 30.3808 32.7316L29.832 33.5547C29.5353 33.9998 29.1703 34.4046 28.7001 34.6468C28.1884 34.9104 27.6423 34.9348 27.1213 34.7612C26.6418 34.6014 26.2198 34.2874 25.8498 33.9355C25.4725 33.5765 25.0909 33.1212 24.7 32.6C24.6957 32.5943 24.6914 32.5885 24.6871 32.5828C24.1016 33.2652 23.4408 33.9734 22.7071 34.7071L22.4142 35L21 33.5858L21.2929 33.2929C22.1794 32.4064 22.9359 31.5775 23.5669 30.806C23.387 30.4778 23.2088 30.1294 23.041 29.7701C22.5076 28.6283 22.0207 27.2543 22.0001 26.0166ZM24.8865 28.9947C24.8916 28.9865 24.8968 28.9783 24.9019 28.9701C25.688 27.7124 26 26.734 26 26C26 25.0291 25.7794 24.5281 25.5913 24.2907C25.4219 24.077 25.2212 24 25 24C24.8035 24 23.9725 24.3466 23.9999 25.9833C24.0133 26.7935 24.3554 27.8582 24.853 28.9237C24.8641 28.9474 24.8753 28.9711 24.8865 28.9947Z"
          fill="#222222"
        />
      </svg>
    </React.Fragment>
  );
}
